import $ from 'jquery';

/*global vars*/
/*eslint no-undef: "error"*/
// var ajaxurl = vars.ajaxurl;

$(document).ready(function () {

        if ($('.read-more').length) {
            $('.read-more').on("click", function () {
                let page = $('.filter-wrap').attr("data-page");
                let per_page = $('.filter-wrap').attr("data-per_page");
                let all = $('.filter-wrap').attr("data-all");
                let posttype = $('.read-more').attr("post-type");
                let town = $('.read-more').attr("filter-town");
                let season = $('.read-more').attr("filter-season");
                let theme = $('.read-more').attr("filter-theme");

                //rabiš še CPT in filtre (funkcija)

                ajax_OW_load_more(page, per_page, all, posttype, town, season, theme);

            });
        }
    }
);

function ajax_OW_load_more(page, per_page, all, posttype, town, season, theme) {
    $(".filter-wrap").addClass("loading");
    $.ajax({
        type: "post",
        url: vars.ajaxurl,
        data: {
            action: 'returnOWReadMoreDozivetja',
            page: page,
            per_page: per_page,
            all: all,
            posttype: posttype,
            town: town,
            season: season,
            theme: theme,
        },
        success: function (data) {
            if ((parseInt(page) + 1) * parseInt(per_page) >= parseInt(all)) {
                $('#load-more-nav').slideUp(500);
            }

            $(".filter-wrap").removeClass("loading");
            $(".filter-wrap").append(data);
            $('.filter-wrap').attr('data-page', parseInt(page) + 1);

        }
        ,
        error: function () {
            $(".filter-wrap").removeClass("loading");
            alert("error");
        }
    });
}

//funkcija ki gre čez vse filtre in vrne array ["acf_meta_name" -> "meta values", "acf meta nem...."]